module.exports = __webpack_public_path__ + "img/1530778286.03f34701.jpg";